import { FC, PropsWithChildren } from 'react';
import { ConfigProvider } from 'antd';
import ruRU from 'antd/lib/locale/ru_RU';
export const CalendarScheduleProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  return (
    <>
      <ConfigProvider
        locale={ruRU}
        theme={{
          components: {
            Calendar: {
              fontSize: 15,
              lineWidth: 1,
              borderRadiusSM: 10,
              borderRadiusLG: 16,
              controlHeightSM: 35,
              fontFamily: 'Inter',
              colorSplit: undefined,
              fontWeightStrong: 700,
              itemActiveBg: '#fwefvf',
              colorPrimary: `var(--blue-light-main)`,
              controlItemBgHover: `var(--black-dark-8)`,
              paddingXXS: 2,
            },
            Select: {
              selectorBg: 'rgba(18, 18, 18, 0.04)',
              optionSelectedBg: undefined,
              optionActiveBg: 'var(--black-dark-8)',
              activeBorderColor: undefined,
              hoverBorderColor: undefined,
              activeOutlineColor: undefined,
              colorBorder: undefined,
              borderRadiusSM: 10,
            },
          },
        }}
      >
        {children}
      </ConfigProvider>
    </>
  );
};
